
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9625_3391)"}},[_c('path',{attrs:{"d":"M3.429 1.125V2.25H1.714C.768 2.25 0 3.006 0 3.938v1.687h16V3.937c0-.931-.768-1.687-1.714-1.687H12.57V1.125C12.571.503 12.061 0 11.43 0c-.633 0-1.143.503-1.143 1.125V2.25H5.714V1.125C5.714.503 5.204 0 4.571 0 3.94 0 3.43.503 3.43 1.125zM16 6.75H0v9.563C0 17.244.768 18 1.714 18h12.572c.946 0 1.714-.756 1.714-1.688V6.75zM8 8.719c.475 0 .857.376.857.844v1.968h2c.475 0 .857.376.857.844a.849.849 0 01-.857.844h-2v1.969A.848.848 0 018 16.03a.848.848 0 01-.857-.843v-1.97h-2a.849.849 0 01-.857-.843c0-.468.382-.844.857-.844h2V9.562c0-.467.382-.843.857-.843z","fill":"#20182E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9625_3391"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v18H0z"}})])])])
          )
        }
      }
    